import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Providers } from './app/providers';
import { router } from './app/routes';
import { initConsentedHeadTags } from './lib/consent';
import './index.css';

initConsentedHeadTags();

// A deploy replaces the hashed chunk files, and a tab opened before it holds
// an index.html that still asks for the old names. The first lazy navigation
// then fails with "Failed to fetch dynamically imported module" and the
// router shows its error page. Vite announces exactly this moment; one
// reload fetches the fresh page, which knows the new names. Guarded so a
// genuinely broken deploy degrades to the error page instead of a loop.
window.addEventListener('vite:preloadError', (event) => {
  try {
    const KEY = 'trackilero.chunkReloadAt';
    const last = Number(sessionStorage.getItem(KEY) ?? 0);
    if (Date.now() - last < 30_000) return;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    // Storage unavailable: reload anyway, once per page lifetime by nature.
  }
  event.preventDefault();
  window.location.reload();
});

const container = document.getElementById('root');
if (!container) throw new Error('No #root element in the document.');

createRoot(container).render(
  <StrictMode>
    <Providers>
      <Suspense fallback={<div className="min-h-[100dvh] bg-canvas" aria-busy="true" />}>
        <RouterProvider router={router} />
      </Suspense>
    </Providers>
  </StrictMode>,
);
